module.exports = __webpack_public_path__ + "076ec82ab34364433fde101664969950.svg";